import { MouseEventHandler } from 'react';
import styled from 'styled-components';

import { lima, razzmatazz } from '@paradigm/design-system/src/colors';

import BoldCross from '@paradigm/design-system/src/assets/BoldCross';
import ArrowDownCrossed from '@paradigm/design-system/src/assets/ArrowDownCrossed';

import { MOBILE_BREAKPOINT } from '#/containers/layout/constants';

interface Props {
  readonly onKillBids: MouseEventHandler<HTMLButtonElement>;
  readonly onKillAsks: MouseEventHandler<HTMLButtonElement>;
  readonly onKillAll: MouseEventHandler<HTMLButtonElement>;
  readonly disabled: boolean;
  readonly className?: string;
}

export default function BatchKillButtons(props: Props) {
  const {
    onKillBids,
    onKillAsks,
    onKillAll,
    disabled = false,
    className,
  } = props;
  return (
    <Container className={className} data-testid="orders-batch-actions">
      <Button
        onClick={onKillBids}
        disabled={disabled}
        data-testid="kill-desk-bids"
      >
        <IconWrapper>
          <ArrowDownCrossed width={13} color={lima} transform="scale(-1,-1)" />
        </IconWrapper>
        <span>Kill Desk Bids</span>
      </Button>
      <Button
        onClick={onKillAsks}
        disabled={disabled}
        data-testid="kill-desk-asks"
      >
        <IconWrapper>
          <ArrowDownCrossed width={13} color={razzmatazz} />
        </IconWrapper>
        <span>Kill Desk Asks</span>
      </Button>
      <Button onClick={onKillAll} disabled={disabled} data-testid="kill-all">
        <IconWrapper>
          <BoldCross width={10} color={razzmatazz} />
        </IconWrapper>
        <span>Kill All</span>
      </Button>
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  gap: 16px;
`;

const Button = styled.button`
  display: grid;
  grid-template-columns: 13px auto;
  gap: 4px;
  align-items: center;
  font-size: 14px;
  line-height: 14px;
  color: white;
  cursor: pointer;
  padding: 3px 5px;
  border: 0;
  border-radius: 4px;
  background: none;
  transition: color 0.16s ease, box-shadow 0.16s ease;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  :hover {
    color: #ccc;
  }
  :active {
    color: #aaa;
  }
  :focus {
    box-shadow: 0 0 0 1px #ccc;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    margin: 1.25rem 0;
    font-size: 1rem;
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  > * {
    display: block;
    margin: auto;
  }
`;
